export * from './dokument-hinterlegen-post-request.interface';
export * from './dokument-hinterlegen-post-response.interface';
export * from './dokument-hinterlegen-post.shapes';
